import { Button, Stack, Text, Title } from '@mantine/core';
import { useDocumentTitle } from '@mantine/hooks';
import { Link } from 'react-router-dom';

import { MERCURY_DOCUMENT_TITLE } from '@/constants';

const NotFound = () => {
  useDocumentTitle(MERCURY_DOCUMENT_TITLE('Page not found'));

  return (
    <Stack align="center" justify="center" gap="md" mih="60vh" p="xl">
      <Title order={2}>Page not found</Title>
      <Text c="dimmed" ta="center" maw={480}>
        The page you are looking for does not exist or has been moved.
      </Text>
      <Button component={Link} to="/">
        Go to home
      </Button>
    </Stack>
  );
};

export default NotFound;
